import { store } from '@/redux/store'

import { W3ResponseType } from '../events'
import { w3Api } from '../w3Api'

export interface DailyPoint {
  id: string
  createdAt: string
  updatedAt: string
  description: string
  type: string
  startAt: string
  endAt: string
  isDeleted: boolean
  isActive: boolean
  userPromotion: any
  checkinDailyConfig: CheckinDailyConfig
  userCheckin: UserCheckin
}

export interface CheckinDailyConfig {
  id: string
  createdAt: string
  updatedAt: string
  pointsDay1: number
  pointsDay2: number
  pointsDay3: number
  pointsDay4: number
  pointsDay5: number
  pointsDay6: number
  pointsDay7: number
}

export interface UserCheckin {
  day1: boolean
  day2: boolean
  day3: boolean
  day4: boolean
  day5: boolean
  day6: boolean
  day7: boolean
  startAt: string
  endAt: string
  currentDay: string
}

export const endpoints = {
  getList: '/promotions/check-in-daily',
  checkin: '/promotions/check-in-daily/:promotionId/check',
}

const DailyCheckinApi = w3Api.injectEndpoints({
  endpoints: (build) => ({
    getListDailyCheckin: build.query<DailyPoint, { creatorId: string }>({
      query: () => {
        return {
          url: endpoints.getList,
        }
      },
      providesTags: (result, error, { creatorId }) => ['daily-checkin', { type: 'Profile', id: creatorId }],
    }),
    checkinDaily: build.mutation<
      W3ResponseType,
      {
        id: string
      }
    >({
      query: ({ id }) => {
        return {
          url: endpoints.checkin.replace(':promotionId', id),
          method: 'POST',
        }
      },
      invalidatesTags() {
        const state = store.getState()
        const creator = state.root.auth.user?.id
        return ['daily-checkin', { type: 'Profile', id: creator }]
      },
    }),
  }),
  overrideExisting: false,
})

export const { useGetListDailyCheckinQuery, useCheckinDailyMutation } = DailyCheckinApi
